"use client";

import { useState } from "react";
import { ErrorsFeature, LeaderboardFeature, PnlSnapshotFeature } from "./features";
import { Accordion } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { clientConfig } from "@/lib/config/client-config";
import { Bug, X } from "lucide-react";

const isLocalOrDevelopment = (nodeEnv: string) => {
  return nodeEnv === "local" || nodeEnv === "development";
};

export const DevHelper = () => {
  const [open, setOpen] = useState(false);

  // Only show in local or development environment
  if (!isLocalOrDevelopment(clientConfig.nodeEnv)) {
    return null;
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="primary"
          size="icon"
          className="fixed bottom-20 right-6 z-50 h-12 w-12 rounded-full shadow-lg hover:shadow-xl transition-shadow"
          aria-label="Dev Helper"
        >
          <Bug className="h-5 w-5" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        side="top"
        align="end"
        className="w-[460px] p-0 rounded-large border-container shadow-xl backdrop-blur-lg bg-cede-bg-popover/90"
      >
        <Card className="border-0 shadow-none bg-transparent">
          <CardHeader className="px-5 pt-4 pb-3">
            <div className="flex items-start justify-between">
              <div className="pr-2">
                <CardTitle className="text-xl">Dev Helper</CardTitle>
                <CardDescription className="mt-1">Development tools and testing utilities</CardDescription>
              </div>
              <Button
                variant="ghost"
                size="icon"
                className="h-8 w-8 hover:bg-cede-primary/10"
                onClick={() => setOpen(false)}
                aria-label="Close"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          </CardHeader>
          <CardContent className="px-3 pb-4">
            <Accordion type="single" collapsible className="w-full space-y-2">
              <ErrorsFeature />
              <LeaderboardFeature />
              <PnlSnapshotFeature />
            </Accordion>
          </CardContent>
        </Card>
      </PopoverContent>
    </Popover>
  );
};
